<!-- CopyRight (C) 2017-2022 Alibaba Group Holding Limited. -->
<!-- Created by Tw93 on 16/10/25. -->
<!--A top navigation bar.-->

<template>
  <v-toolbar color="primary" dark>
    <v-toolbar-side-icon>
      <img
        alt="EzCred"
        src="../../../src/assets/ezcred_logo_white.png"
        style="max-width: 100%; max-height: 100%"
        @click="leftButtonClicked"
      />
    </v-toolbar-side-icon>

    <v-toolbar-title class="white--text">
      <h5>{{ title }}</h5>
      <h6>{{ subTitle }}</h6>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn icon v-if="showMoreVert" @click="rightButtonClicked">
      <v-icon>more_vert</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<style scoped>
.wxc-minibar {
  width: 750px;
  height: 90px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.left {
  padding-left: 32px;
}

.middle-title {
  font-size: 30px;
  color: #ffffff;
  height: 36px;
  line-height: 34px;
}

.right {
  padding-right: 32px;
  align-items: flex-end;
}

.left-button {
  width: 21px;
  height: 36px;
}

.right-button {
  width: 32px;
  height: 32px;
}

.icon-text {
  font-size: 28px;
  color: #ffffff;
}

.box-shadow-none {
  box-shadow: 0px 0px 0px 0px !important;
}
</style>

<script>
// const Navigator = weex.requireModule('navigator');
export default {
  props: {
    backgroundColor: {
      type: String,
      default: "#FFC900",
    },
    leftButton: {
      type: String,
      default:
        "https://ezcred-public-docs.s3.ap-south-1.amazonaws.com/resources/app/ezcred_logo_white.png",
    },
    textColor: {
      type: String,
      default: "#3D3D3D",
    },
    rightButton: {
      type: String,
      default: "",
    },
    showMoreVert: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "标题",
    },
    subTitle: {
      type: String,
      default: "",
    },
    leftText: {
      type: String,
      default: "",
    },
    rightText: {
      type: String,
      default: "",
    },
    useDefaultReturn: {
      type: Boolean,
      default: true,
    },
    show: {
      type: Boolean,
      default: true,
    },
    barStyle: {
      type: Object,
    },
  },
  computed: {
    newBarStyle() {
      const { backgroundColor, barStyle } = this;
      return {
        backgroundColor,
        ...barStyle,
      };
    },

    leftDivStyle() {
      let divStyle = { width: "80px" };
      if (this.leftText) {
        divStyle = { width: "180px" };
      }

      return divStyle;
    },

    rightDivStyle() {
      let divStyle = { width: "80px" };
      if (this.rightText) {
        divStyle = { width: "180px" };
      }

      return divStyle;
    },
  },
  methods: {
    leftButtonClicked() {
      if (this.useDefaultReturn) {
        // Navigator.pop({}, e => {
        // });
      }
      this.$emit("wxcMinibarLeftButtonClicked", {});
    },
    rightButtonClicked() {
      // const hasRightContent = this.rightText || this.rightButton || (this.$slots && this.$slots.right);
      // hasRightContent && this.$emit('wxcMinibarRightButtonClicked', {});
      this.$emit("wxcMinibarRightButtonClicked", {});
    },
  },
};
</script>
